/**
 * WordPress Dependencies
 */
import { useBlockProps, RichText, InnerBlocks } from '@wordpress/block-editor';
import { RawHTML } from '@wordpress/element';

/**
 * External Dependencies
 */
import classNames from 'classnames';

/**
 * Internal Dependencies
 */
import ICONS from '../../controls/icon-picker-control/icons';

const Save = props => {
    const { attributes } = props;
    const { uniqueId, titleTag, title, sourceType, icon, customIcon } = attributes;

    const blockProps = useBlockProps.save({
        className: classNames('faq-accordion-item', uniqueId)
    });

    return (
        <div {...blockProps}>
            <div className="faq-accordion-header">
                <RichText.Content tagName={titleTag} className="faq-accordion-button" value={title} />
                <span className="faq-accordion-icon">
                    {sourceType === 'library' ? ICONS[icon] : <RawHTML>{customIcon}</RawHTML>}
                </span>
            </div>
            <div className="faq-accordion-collapse">
                <div className="faq-accordion-body">
                    <InnerBlocks.Content />
                </div>
            </div>
        </div>
    );
};

export default Save;
